import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { SearchFiltersCheckboxes } from '../../components/search-filters-checkbox/search-filters-checkboxes'

export const BootSpace = withFacetContext(
    FacetName.boot_size_values,
    withFilterContext(FilterName.boot_size_values, SearchFiltersCheckboxes, {
        title: 'Boot space',
    })
)
